var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.isBusy,
              expression: "isBusy",
            },
          ],
          ref: "form",
          attrs: {
            model: _vm.form,
            rules: _vm.rules,
            "element-loading-spinner": "el-icon-loading",
            "label-position": "top",
          },
        },
        [
          _c(
            "el-form-item",
            {
              attrs: { prop: "value" },
              scopedSlots: _vm._u([
                {
                  key: "label",
                  fn: function () {
                    return [
                      _vm.description
                        ? _c(
                            "el-tooltip",
                            {
                              attrs: {
                                effect: "light",
                                content: _vm.description,
                                placement: "top-start",
                              },
                            },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.name) + " "),
                                _c("i", {
                                  staticClass: "far fa-question-circle",
                                }),
                              ]),
                            ]
                          )
                        : _c("span", [_vm._v(_vm._s(_vm.name))]),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _vm._v(" "),
              _c("el-input", {
                attrs: { placeholder: _vm.name },
                model: {
                  value: _vm.form.value,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "value", $$v)
                  },
                  expression: "form.value",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "button",
        { staticClass: "btn btn-create px-4", on: { click: _vm.store } },
        [_vm._v("Store")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }